import React from "react";
import { Carousel, Dropdown, Icon, Modal, Switcher } from "pepsico-ds";
import "./welcome.css";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import page from "../../Component-Library/Error404";
import landingService from "./landing_pageservice";
import { useLoading } from "../../loader";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import URLData from "../../Data/URL-Data";
import custom_icon from "../../assets/side-navigation/power_BI_Logo.svg";
import view_request_icon from "../../assets/app-logo/view-request.png";
import { useUserProfile } from "../../common/user_profile_context";
import { startTour } from '../../common/tourUtils';
import { Tooltip } from 'react-tooltip'
import { useOktaAuth } from "@okta/okta-react";
import { useDispatch, useSelector } from "react-redux";
import { homeSelectedQuickLinkIndex, homeSelectedQuickLink } from "../../Redux/Actions/home";

const WelcomeJs = ({ onSelect, setSelectCard, myidMApprovalCount, isManager, roles }) => {
  const { oktaAuth } = useOktaAuth();
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const quickLinkSelectedIndex = useSelector((state)=>state?.homeState?.index);
  const selectedQuickLink = useSelector((state)=>state?.homeState?.selectedQuickLink);
  const { userProfile, loading } = useUserProfile();  
  const [isPkiCertsModalOpen, setIsPkiCertsModalOpen] = useState(false);
  const closePkiCertsModal = () => setIsPkiCertsModalOpen(false);
  const navigate = useNavigate();
  // const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const { showLoader, hideLoader } = useLoading();
  // const [selectedQuickLink, setSelectedQuickLink] = useState([
  //   {
  //     displayText: "myidM",
  //     id: 0,
  //   },
  // ]);
  const [pkiToken, setPkiToken] = useState(null);
  const [pkiCertData, setPkiCertData] = useState({});
  const userData = JSON.parse(localStorage.getItem("okta-token-storage"));
  const [hasFetchedPKIToken, setHasFetchedPKIToken] = useState(false);

  const [currentStep, setCurrentStep] = useState(0);
  const quickLinks = [
    {
      displayText: "myidM",
      id: 0,
    },
    {
      displayText: "SSO",
      id: 1,
    },
    {
      displayText: "pepAGM",
      id: 2,
    },
    {
      displayText: "PKI",
      id: 3,
    },
    {
      displayText: "myPAM",
      id: 4,
    },
    {
      displayText: "Directory Services",
      id: 5,
    },
    {
      displayText: "CIAM",
      id: 6,
    },
    {
      displayText: "More options...",
      id: 7,
    },
  ];
  const [carouselKey, setCarouselKey] = useState(0);
  const [isMobile, setIsMobile] = useState(window.screen.width <= 768);
  const [selectedView, setSelectedView] = useState("halfCard");
  const getItemsPerSlide = () => {
    if (/\/home(\/|$)/.test(window.location.pathname)) {
      const cardContainer = document.getElementById("quick-links-cards-container");
      if(cardContainer && cardContainer?.clientWidth && window.screen.width > 768){
        const containerWidth = cardContainer?.clientWidth;
        const perItemSizeWithMargin = 272; // 260+12
        const NumberOfItemPossibleInSingleRow = Math.floor(containerWidth/perItemSizeWithMargin);
        return window.screen.width<containerWidth ? NumberOfItemPossibleInSingleRow-1 : NumberOfItemPossibleInSingleRow;
      }else{
        const width = window.screen.width;
        if (width <= 768) return 1;
        if (width <= 1024) return 3;
        if (width <= 1440) return 4;
        if (width <= 1640) return 5;
        if (width <= 1990) return 6;
        if (width <= 2560) return 9;
        return 10; // Large Desktop
      }
    } else {
      const width = window.screen.width;
      if (width <= 768) return 1;
      if (width <= 1024) return 2;
      if (width <= 1640) return 3;
      if (width <= 1990) return 4;

      return 5; // Large Desktop
    }
  };
  const [itemsPerSlide, setItemsPerSlide] = useState(getItemsPerSlide());

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.screen.width <= 768);
      setCarouselKey((prevKey) => prevKey + 1);
      setItemsPerSlide(getItemsPerSlide());
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  
  useEffect(() => {
    // console.log("userProfile changed", userProfile);
    if (loading || !userProfile) return;
  }, [userProfile]);

  let accessTypes = [
    // {
    //   id: "approve_idm",
    //   type: "myidM",
    //   title: t("homePage.view_request"),
    //   subTitle: t("homePage.view_request_desc"),
    //   path: "audit_requests",
    //   target: "secretPepsicoUrl",
    // },
    {
      id: "change_password",
      type: "myidM",
      title: t("homePage.change_password"),
      subTitle: t("homePage.change_password_desc"),
      path: "change_password",
      target: "secretPepsicoUrl",
    },
    {
      id: "request_access",
      type: "myidM",
      title: t("homePage.request_access"),
      subTitle: t("homePage.request_access_desc"),
      path: "request_access",
      target: "secretPepsicoUrl",
    },
    (userProfile?.associateType?.toLowerCase() !== "thirdparty") && {
      id: "request_access_others",
      type: "myidM",
      title: t("homePage.request_access_others"),
      subTitle: t("homePage.request_access_others_desc"),
      path: "request_access_others",
      target: "secretPepsicoUrl",
    },
    ...(userProfile?.isIREnabled ? [{
      id: "mypam",
      type: "myidM",
      title: t("ir.suspend_service_account"),
      subTitle: "",
      path: "suspend_service_account",
      target: "secretPepsicoUrl",
    }
  ] : []),
    {
      id: "profile_update_idm",
      type: "myidM",
      title: userProfile?.pepappiamcentralfeatures?.includes('UpdateProfile') ? t("homePage.update_profile") : t("homePage.view_profile"),
      subTitle: userProfile?.pepappiamcentralfeatures?.includes('UpdateProfile') ? t("homePage.update_profile_desc") : t("homePage.view_profile_desc"),
      path: "update_profile",
      target: "secretPepsicoUrl",
    },
    // {
    //   id: "others_profile_update_idm",
    //   type: "myidM",
    //   title: t("homePage.update_profile_others"),
    //   subTitle: t("homePage.update_profile_desc"),
    //   path: "update_profile_others",
    //   target: "secretPepsicoUrl",
    // },
    (userProfile?.associateType?.toLowerCase() === "contractor" ||
      userProfile?.associateType?.toLowerCase() === "thirdparty") && {
      id: "reactivate_nonemployee_idm",
      type: "myidM",
      title: t("homePage.extension_self"),
      subTitle: t("homePage.extension_self"),
      path: "extension-request",
      target: "secretPepsicoUrl",
    },
    userProfile?.associateType?.toLowerCase() !== "thirdparty" && {
      id: "revalidate_nonemployee_idm",
      type: "myidM",
      title: t("homePage.extension_others"),
      subTitle: t("homePage.extension_others"),
      path: "single-extension-reactivation",
      target: "secretPepsicoUrl",
    },
    isManager && {
      id: "revalidate_nonemployee_idm",
      type: "myidM",
      title: t("homePage.bulk_revalidation"),
      subTitle: t("homePage.bulk_revalidation"),
      path: "bulk-revalidation",
      target: "secretPepsicoUrl",
    },
    {
      id: "mycert_portal",
      type: "PKI",
      title: t("homePage.mycert_portal"),
      subTitle: "",
      path: "https://mycert-pepsico.appvx.com/appviewx/login",
      target: "secretPepsicoUrl",
    },
    {
      id: "mycert_request",
      type: "PKI",
      title: t("homePage.mycert_requests"),
      subTitle: "",
      path: "https://pepsico.service-now.com/com.glideapp.servicecatalog_cat_item_view.do?v=1&sysparm_id=68fac3dc83c85ed02eeef1a8beaad390&sysparm_link_parent=11d60ce50f511700fa1b1b1e51050e82&sysparm_catalog=e0d08b13c3330100c8b837659bba8fb4&sysparm_catalog_view=catalog_default&sysparm_view=catalog_default",
      target: "secretPepsicoUrl",
    },
    {
      id: "mycert_help",
      type: "PKI",
      title: t("homePage.mycert_help"),
      subTitle: "",
      path: "https://pepsico.sharepoint.com/sites/myCert/userportal/SitePages/Home.aspx",
      target: "secretPepsicoUrl",
    },
    {
      id: "mycert_certificates",
      type: "PKI",
      title: t("homePage.certificate_expiry_dashboard_summary_insights"),
      subTitle: "",
      path: "https://mycert-pepsico.appvx.com/appviewx/app#certificate/insights/summary",
      target: "secretPepsicoUrl",
    },
    {
      id: "sso_app_onboarding",
      type: "SSO",
      title: t("homePage.sso_app_onboarding"),
      subTitle: "",
      path: "sso_onboarding",
      target: "secretPepsicoUrl",
    },
    {
      id: "sso_app_modification",
      type: "SSO",
      title: t("homePage.sso_app_modification"),
      subTitle: "",
      path: "sso_app_modification",
      target: "secretPepsicoUrl",
    },
    {
      id: "mfa_reset_sso",
      type: "SSO",
      title: t("homePage.update_mfa_factors"),
      subTitle: "",
      path: "https://secure.pepsico.com/enduser/settings",
      target: "secretPepsicoUrl",
    },
    {
      id: "pending_campaigns",
      type: "pepAGM",
      title: t("homePage.pep_agm"),
      subTitle: "",
      path: "https://pepagm.mypepsico.com/sigma/app/index#/campaigns",
      target: "secretPepsicoUrl",
    },
    {
      id: "pep_agm_pep",
      type: "pepAGM",
      title: t("homePage.pepagm_help_resources"),
      subTitle: "",
      path: "https://www.mypepsico.com/wps/myportal/web/MyPepsiCo/company/systems-and-applications/pepagm/resources/!ut/p/z1/tVNdb5swFP0re8mj5Qs2YB4pTT_o6MdSEvALMuAQqtjQQL_262e6VpumJWzaalm2bJ17ru_xuZjjFHMtHptaDE2rxdacM-7m12zunkVgX1x5HkCwvPLhZHESMM_Fq1dAfGq51hGFz3ALBmBFATu-YGBRB_P98ae35C0e9owApuKXmGO-FboON2aROJN6vOnKpsIZlJUj_LVAjBY2otIqke8WHiptSd3CTCb9EV3qoRs2OFNd_iSLvGz1IPWQb5sil3oG7cPuU9mqTuiXGfQv_SBVL3Qlum7blK9K9TPoZCdqNYOd7A2-lP1baQfezv9E2gMAfli51VjaxOdMcfBfHnk-n0NwBMsbGvoQHtOJFLaFM1OFt1cF4uDVYyOfcKLbnTKGW4yMqzDOb5L5FxO772uJAFJYPkEWqQpEmUtQwaiDCGF0XTkF2ILiM5hIH8FHpo-mzGu6y97FYVwbWjFsUKPXLU5F0T4M6LufcPq-46y5u7_ngXHraM_nAaf_w64_J3u_xQtT6kHh2KX9O-H-ousm6J1_pI-mmuuj9PzR_p1KEsWIQkkKzTnKoruv602tri8Rz9jA4jlxapXH_TekQCwD/dz/d5/L2dBISEvZ0FBIS9nQSEh/",
      target: "secretPepsicoUrl",
    },
    {
      id: "mypam",
      type: "myPAM",
      title: t("homePage.mypam"),
      subTitle: t("homePage.mypam_desc"),
      path: "https://mypam.intra.pepsico.com",
      target: "secretPepsicoUrl",
    },
    {
      id: "mypam",
      type: "myPAM",
      title: t("menu.mypam_svc_onboard"),
      subTitle: t("menu.mypam_svc_onboard"),
      path: "svc_acc",
      target: "secretPepsicoUrl",
    },
    userProfile?.pepappiamcentralfeatures?.includes('PamSVCApproval') && {
      id: "mypam",
      type: "myPAM",
      title: t("menu.mypam_svc_onboard_approval"),
      subTitle: t("menu.mypam_svc_onboard_approval"),
      path: "svc_acc_approval",
      target: "secretPepsicoUrl",
    },
    ...(userProfile?.pepappiamcentralfeatures?.includes('SafeManagement') ? [{
      id: "mypam",
      type: "myPAM",
      title: t("mypam.safe_management"),
      subTitle: t("mypam.myPAM_safe_management"),
      path: "safe_create_update",
      target: "secretPepsicoUrl",
    }
    // ,
    // {
    //   id: "mypam",
    //   type: "myPAM",
    //   title: t("mypam.myPAM_safe_access_request"),
    //   subTitle: t("mypam.myPAM_safe_access_request"),
    //   path: "safe_access_request",
    //   target: "secretPepsicoUrl",
    // }
  ] : []),
    userProfile?.pepappiamcentralfeatures?.includes('ADDashboard') && {
      id: "ad_dashboard",
      type: "Directory Services",
      title: t("homePage.active_directory_dashboard"),
      subTitle: "",
      path: "active_directory",
      target: "secretPepsicoUrl",
    },
    ...( (userProfile?.associateType?.toLowerCase()?.includes("employee") && userProfile?.pepappiamcentralfeatures?.includes('GuestInvitation')) ? [{
      id: "ad_dashboard",
      type: "Directory Services",
      title: t("homePage.m365_guest_invitation_request"),
      subTitle: "",
      path: "guest_invitation",
      target: "secretPepsicoUrl",
    },
    {
      id: "ad_dashboard",
      type: "Directory Services",
      title: t("homePage.m365_guest_management"),
      subTitle: "",
      path: "guest_management",
      target: "secretPepsicoUrl",
    }] : []),
    ...(userProfile?.pepappiamcentralfeatures?.includes('EntraAppRegistration') ? [{
      id: "ds_request",
      type: "Directory Services",
      title: t("app_registeration.entra_azure_application_registeration"),
      subTitle: t("app_registeration.entra_azure_application_registeration"),
      path: "application_registeration",
      target: "secretPepsicoUrl",
    }] : []),
    ...(userProfile?.pepappiamcentralfeatures?.includes('AttributeBulkLoad') ? [{
      id: "ds_reset",
      type: "Directory Services",
      title: t("idx.attribute_bulk_load"),
      subTitle: "",
      path: "idx_bulk_load",
      target: "secretPepsicoUrl",
    }] : []),
    ...(userProfile?.pepappiamcentralfeatures?.includes('SelfReporting') ? [{
      id: "ds_reset",
      type: "Directory Services",
      title: t("idx.reporting_self_service"),
      subTitle: "",
      path: "idx_self_service",
      target: "secretPepsicoUrl",
    }] : []),
    // {
    //   id: "ds_reset",
    //   type: "Directory Services",
    //   title: t("homePage.idx_test_account_reset"),
    //   subTitle: t("homePage.idx_test_account_reset_desc"),
    //   path: "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=IDXITEPasswordreset",
    //   target: "secretPepsicoUrl",
    // },
    ...(userProfile?.pepappiamcentralfeatures?.includes('IDXITEPasswordReset') ? [{
      id: "ds_reset",
      type: "Directory Services",
      title: t("homePage.idx_test_account_reset"),
      subTitle: t("homePage.idx_test_account_reset_desc"),
      path: "idx_preprod_password_reset",
    }] : []),
    {
      id: "ds_request",
      type: "Directory Services",
      title: t("homePage.myits_service_request"),
      subTitle: t("homePage.myits_service_request_desc"),
      path: "https://pepsico.service-now.com/now/nav/ui/classic/params/target/com.glideapp.servicecatalog_cat_item_view.do%3Fv%3D1%26sysparm_id%3Defbdd2f047b6a2102d2b30ffe16d439c%26sysparm_link_parent%3D18c548650f511700fa1b1b1e51050ef5%26sysparm_catalog%3De0d08b13c3330100c8b837659bba8fb4%26sysparm_catalog_view%3Dcatalog_default%26sysparm_view%3Dcatalog_default",
      target: "secretPepsicoUrl",
    },
    // {
    //   id: "ds_request",
    //   type: "Directory Services",
    //   title: t("homePage.idx_test_id_creation"),
    //   subTitle: t("homePage.idx_test_id_creation_desc"),
    //   path: "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=IdxTestIdCreation",
    //   target: "secretPepsicoUrl",
    // },
...(userProfile?.pepappiamcentralfeatures?.includes('IDXTestIDCreation')
  ? [{
      id: "ds_request",
      type: "Directory Services",
      title: t("homePage.idx_test_id_creation"),
      subTitle: t("homePage.idx_test_id_creation_desc"),
      path: "idx_testid_request_preprod",
    }]
  : []),
...(userProfile?.pepappiamcentralfeatures?.includes('IDXGroupMember')
  ? [{
      id: "idx_preprod_group_membership",
      type: "Directory Services",
      title: t("idx.idx_preprod_group_membership"),
      subTitle: t("idx.idx_preprod_group_membership_desc"),
      path: "idx_preprod_group_membership",
    }]
  : []),

// ...(userProfile?.pepappiamcentralfeatures?.includes('ApplicationAccessBulk')
//   ? [{
//       id: "idx_preprod_app_access",
//       type: "Directory Services",
//       title: t("idx.preprod_application_access"),
//        subTitle: t("idx.preprod_application_access_desc"),
//       path: "idx_preprod_application_access",
//     }]
//   : []),

...(userProfile?.pepappiamcentralfeatures?.includes('IDXITEAppAccess') ? [{
  id: "idx_preprod_app_access",
  type: "Directory Services",
  title: t("idx.preprod_application_access"),
  subTitle: t("idx.preprod_application_access_desc"),
  path: "idx_preprod_application_access",
}] : []),
// {
//   id: "idx_preprod_password_reset",
//   type: "Directory Services",
//   title: t("idx.preprod_password_reset"),
//   subTitle: t("idx.preprod_password_reset_desc"),
//   path: "idx_preprod_password_reset",
//   //target: "secretPepsicoUrl",
// },
    {
      id: "ds_reset",
      type: "CIAM",
      title: t("homePage.ciam_submit_request"),
      subTitle: t("homePage.ciam_submit_request_desc"),
      path: "https://forms.office.com/r/5chXKfaF5w",
      target: "secretPepsicoUrl",
    },
    {
      id: "ds_request",
      type: "CIAM",
      title: t("homePage.ciam_onboard_request"),
      subTitle: t("homePage.ciam_onboard_request_desc"),
      path: " https://secure-admin-partner.pepsico.com/",
      target: "secretPepsicoUrl",
    },
    {
      id: "security_option",
      type: "More Options",
      title: "myidM",
      subTitle: "IDX Test Account Reset",
      path: "https://myidm.mypepsico.com/",

      target: "secretPepsicoUrl",
    },
    {
      id: "security_option",
      type: "More Options",
      title: "Service Now Request",
      subTitle: "myITS Service Request",
      path: "https://pepsico.service-now.com/now/nav/ui/classic/params/target/com.glideapp.servicecatalog_cat_item_view.do%3Fv%3D1%26sysparm_id%3D2a649c570fd9db00ecd0fd4ce1050eaf%26sysparm_link_parent%3D11d60ce50f511700fa1b1b1e51050e82%26sysparm_catalog%3De0d08b13c3330100c8b837659bba8fb4%26sysparm_catalog_view%3Dcatalog_IT_Services_Catalog%26sysparm_view%3Dcatalogs_default",
      target: "secretPepsicoUrl",
    },
    //myITS Service Request
    {
      id: "security_option",
      type: "coming_soon",
      title: "Coming Soon",
      subTitle: "Under Development",
      path: "",
    },
    // {
    //   id: "ad_dashboard",
    //   type: "Directory Services",
    //   title: t("homePage.active_directory_dashboard"),
    //   subTitle: "",
    //   path: "active_directory",
    //   target: "secretPepsicoUrl",
    // },
    {
      id: "ad_dashboard",
      type: "myidM",
      title: t("homePage.rapid_application_onboarding"),
      subTitle: "",
      path: "rapid_application_onboarding",
      target: "secretPepsicoUrl",
    },
    {
      id: "application_retirements",
      type: "myidM",
      title: t("app_retirement.application_retirements"),
      subTitle: t("app_retirement.application_retirements"),
      path: "application_retirements",
      target: "secretPepsicoUrl",
    },
    ...(userProfile?.raoApprovalsEnabled ? [{
      id: "review_app_onboarding",
      type: "myidM",
      title: t("homePage.review_application_onboarding"),
      subTitle: "",
      path: "review_application_onboarding",
      target: "secretPepsicoUrl",
    }] : [])
  ];

  const setSlectedCardView = (val) => {
    setSelectedView(val);
    setSelectCard(val);
  };
  const SWITCHER_ITEMS = [
    { key: 'myidM', label: 'myidM' },
    { key: 'SSO', label: 'SSO' },
    { key: 'pepAGM', label: 'pepAGM' },
    { key: 'PKI', label: 'PKI' },
    { key: 'myPAM', label: 'myPAM' },
    { key: 'directory_services', label: t('homePage.directory_services') }, // display translated
    { key: 'CIAM', label: 'CIAM' },
  ];
  
  // If your Switcher supports objects, use items={SWITCHER_ITEMS.map(i => i.label)}
  // And maintain the active key via selectedTabIndex → SWITCHER_ITEMS[index].key
  
  
const TAB_KEYS = ["myidM", "SSO", "pepAGM", "PKI", "myPAM", "directory_services", "CIAM"]; // use stable keys

function getTabKeyByIndex(idx) {
  // NOTE: your Switcher shows a translated label for directory services,
  // but use a stable internal key for selectors and renderSlides('directory_services').
  return TAB_KEYS[idx] ?? 'myidM';
}

function queryAll(container, selector) {
  return Array.from(container.querySelectorAll(selector));
}
const tabKey = getTabKeyByIndex(quickLinkSelectedIndex);;
  const container = document.querySelector(`#tab-${tabKey}`);

  useEffect(() => {
    const handler = (e) => dispatch(homeSelectedQuickLinkIndex({index: e?.detail}));
    window?.addEventListener('switchTab', handler);
    return () => window?.removeEventListener('switchTab', handler);
  }, []);
  
  const selectedTab = (index) => {
    // if (index === 3 && !hasFetchedPKIToken) {
    //   getPkiCertificatesCount();
    //   // setHasFetchedPKIToken(true);
    // }
    if (index?.[0]?.id === 0 || index?.[0]?.id) {
      dispatch(homeSelectedQuickLink({selectedQuickLink: index}));
      dispatch(homeSelectedQuickLinkIndex({index: index?.[0]?.id}));
      const menu = document.querySelector(".menu-list");
      if (menu) {
        menu.style.display = menu.style.display === "none" ? "block" : "none";
      }
    } else {
      dispatch(homeSelectedQuickLinkIndex({index: index}));
      dispatch(homeSelectedQuickLink({selectedQuickLink: [quickLinks[index]]}));
    }
  };

  const hanldleTheNavigation = (linkData) => {
    if (linkData) {
      window.open(`${linkData}`, "_blank", "noopener noreferrer");
    } else {
      const winHtml = page.Error404Page;

      const winUrl = URL.createObjectURL(
        new Blob([winHtml], { type: "text/html" })
      );
      const win = window.open(winUrl, "_blank");
      setTimeout(() => {
        win.close();
      }, 100);
    }
  };

  const navigateToQuickLinks = (path, target, id, type) => {
    if (path === "update_profile") {
console.log("path =", path);
      // const res = await handleSensitiveAction();
      // if(!res || res?.claims?.acr !== "urn:okta:loa:2fa:any") {
      //   toast.error("Action requires multi-factor authentication. Please complete MFA to proceed.", "error");
      //   return;
      // }

      if(userProfile?.pepappiamcentralfeatures?.includes('UpdateProfile')){
        navigate('/update-profile');
      }
      else{
        navigate('/view-profile');
        // if(userProfile?.associateType?.toLowerCase()?.includes("employee") ){
        //   window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsicoModifyEmployeeProfile", "_blank");
        //   // navigate('/update-profile');
        // }
        // else {
        //   window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsicoModifyNonEmployeeProfileForAnother", "_blank");
        //   // navigate('/update-profile');
        // }
    }

      // window.open(
      //   `${JSON.parse(localStorage.getItem("okta-token-storage"))
      //     ?.idToken?.claims?.email?.toLocaleLowerCase()
      //     .includes("contractor")
      //     ? "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsicoModifyNonEmployeeProfileForAnother"
      //     : "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsicoModifyEmployeeProfile"
      //   }`,
      //   "_blank",
      //   "noopener noreferrer"
      // );
    }
    else if (path == "update_profile_others") {
      navigate('/myidm', { state: { navigateFrom: 'update_profile_others' } })
    }
    else if(path == "sso_onboarding"){
      if(userProfile?.pepappiamcentralfeatures?.includes('SSOOnboarding')){
        navigate('/sso-onboarding');
      } else {
        window.open("https://devx-infra.mypepsico.com/sso-okta-onboarding", "_blank", "noopener noreferrer");
      }
    }
    else if(path == "sso_app_modification"){
      if(userProfile?.pepappiamcentralfeatures?.includes('SSOModification')){
        navigate('/sso-modification');
      } else {
        window.open("https://devx-infra.mypepsico.com/sso-okta-modification", "_blank", "noopener noreferrer");
      }
    }
    else if (path === "approvals") {
      if(userProfile?.pepappiamcentralfeatures?.includes('Approvals')){
        navigate('/approvals', { state: { roles, myidMApprovalCount } });
      }
      else{
        window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PendingApprovals","_blank")
      }
    }
    else if (path === "change_password") {
      // if (roles && roles?.includes("iChangePassword")) {
      navigate('/change-password');
      // }
      // else {
      //   URLData.OPEN_URL_CHECKER("myidm", "change_password");
      // }
    }
    else if (path == "single-extension-reactivation") {
      userProfile?.pepappiamcentralfeatures?.includes('ContractorReactivation') ?
      navigate('/single-extension-reactivation') : (
        window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=ExtensionReactivationforAnotherNonEmployee","_blank")
      )
    }
    else if(path == "extension-request"){
      userProfile?.pepappiamcentralfeatures?.includes('ContractorReactivation') ?
      navigate('/extension-request') :
      window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=ExtensionReactivationNonEmployeeSelfRequest","_blank")
    }
    else if(path == "audit_requests"){
        
      if(userProfile?.pepappiamcentralfeatures?.includes('RequestAudit')) 
      {
        let statePayload = { navigateFrom: "extension_request"};
        navigate("/myidmPortal", { state: statePayload });
      }
      else{
        window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=ViewMyRequestsAuditSAP")
      }
    }
    else if (path == "bulk-revalidation") {
      if(userProfile?.pepappiamcentralfeatures?.includes('ContractorReactivation')) 
      {
        navigate('/bulk-revalidation')
      }
      else{
        window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsicoBulkRevalidationNonEmployee")
      }
    }
   else if (path == "request_access") {
  navigate('/request-access');
}
   
    else if (path == "request_access_others"){
      userProfile?.pepappiamcentralfeatures?.includes('RequestAccess') ?
      navigate('/myidmPortal', { state: {navigateFrom: 'request_access_others'} }) :
      window.open(
        "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsiCoRequestAccessForOtherAssociate",
        "_blank"
      );
    }
    else if (id === 'mycert_certificates' && type === 'PKI') {
      navigate('/pki-certificates', { state: { pkiCertData } });
      // setIsPkiCertsModalOpen(true);
      // setPkiCertData({
      //   path: path,
      //   target: target
      // });
      // hanldleTheNavigation(path);
    }
    else if(path === 'svc_acc'){
      navigate('/pam-svc-account');
    }

    else if(path === 'safe_create_update'){
      navigate('/pam-safe-create-update');
    }

    else if(path === 'safe_access_request'){
      navigate('/pam-safe-access-request');
    }
    
    else if(path === 'svc_acc_approval'){
      navigate('/pam-svc-account-approval');
    }
    else if(path === 'active_directory'){
      navigate('/active-directory');
    }
    else if(path === 'application_retirements'){
      navigate('/app-retirement');
    }
    else if(path === 'application_registeration'){
      navigate('/app-registration');
    }
    else if(path === 'guest_invitation'){
      navigate('/guest-invitation-request');
    }
    else if(path === 'guest_management'){
      navigate('/guest-management');
    }
    else if(path === 'idx_bulk_load'){
      navigate('/idx-bulk-load');
    }
    else if(path === 'idx_self_service'){
      navigate('/idx-self-service');
    }
  else if(path === 'idx_testid_request_preprod'){
  navigate('/idx-testid-request-preprod');
}
else if(path === 'idx_preprod_group_membership'){
  navigate('/idx-preprod-group-membership');
}
else if(path === 'idx_preprod_application_access'){
  navigate('/idx-preprod-application-access');
}
else if(path === 'idx_preprod_password_reset'){
  navigate('/idx-preprod-password-reset');
}


    else if(path === 'suspend_service_account'){
      navigate('/ir-suspend-service-account');
    }
    else if(path === 'rapid_application_onboarding'){
      hanldleTheNavigation('https://myidm.mypepsico.com/pepsicorao/request/index.html')
    }
    else if(path === 'review_application_onboarding'){
      hanldleTheNavigation('https://myidm.mypepsico.com/pepsicorao/review/review-section')
    }

    else if (target) {
      console.log("Opening external link:", path);
      hanldleTheNavigation(path);
    } else {
      navigate(path);
    }
  };

  // const fetchPKICertificatesToken = async () => {
  //   // Fetch the PKI certificates token
  //   try {
  //     showLoader();
  //     const response = await landingService.fetchPKICertificatesToken();
  //     hideLoader();

  //     const token = response?.response;
  //     setPkiToken(token);
  //     if (token) {
  //       getPkiCertificatesCount(token);
  //     }
  //     console.log("PKI Certificates Token:", token);
  //   } catch (error) {
  //     hideLoader();

  //   }
  // };

  // const getPkiCertificatesCount = async () => {
  //   try {
  //     showLoader();
  //     const response = await landingService.fetchPKICertificatesCount(userData?.accessToken?.claims?.gpid || "81200748");
  //     setPkiCertData(response.response.output[0]);
  //     hideLoader();

  //     // const response = await landingService.fetchPKICertificatesCount(token, {
  //     //   "payload": {

  //     //     "hook": {
  //     //       "name": "Pepsico - Fetch Expiring Certificate Details for Range Value"
  //     //     },
  //     //     "input": {
  //     //       "gpid": userData?.accessToken?.claims?.gpid || "",
  //     //     }
  //     //   }
  //     // });
  //     console.log("PKI Certificates Count Response:", response);
  //   } catch (error) {
  //     console.error("Error fetching PKI certificates count:", error);
  //     hideLoader();
  //     return null;
  //   }
  // };

  const renderSlides = (headerLabel) => {
    let slides = [];
    const totalSlides = Math.ceil(
      accessTypes.filter((item) => item?.type === headerLabel).length /
      itemsPerSlide
    );
    const filteredItems = accessTypes.filter(
      (item) => item?.type === headerLabel
    );

  for (let i = 0; i < totalSlides; i++) {
    const startIndex = i * itemsPerSlide;
    const endIndex = startIndex + itemsPerSlide;
    const items = filteredItems.slice(startIndex, endIndex);

    slides.push(
      <div style={{ display: "flex" }} key={`slide-${i}`} id="quick-links-cards-container">
        <div className="cards-container">
          {items.map((accessType, index) => {
            const cardKey = `${accessType?.id}-${i}-${index}`;
            const tabKey = headerLabel; // e.g., 'myidM', 'SSO', etc.

            return (
              <div
                key={cardKey}
                className="card idmCard h-auto"
                id={`card-${tabKey}-${accessType?.id}`}
              >
                <div
                  className="card-content my-0"
                  style={{ margin: "auto" }}
                  onClick={() =>
                    navigateToQuickLinks(accessType?.path, accessType?.target, accessType?.id, accessType?.type)
                  }
                >
                  <div className="d-flex col-12">
                    <div className={`${accessType?.id}_logo`}></div>
                    <div
                      className="col-9"
                      style={{
                        margin: "auto auto auto 6px",
                        display: "grid",
                        maxWidth: "76%",
                        flex: "0 0 76%",
                      }}
                    >
                      <div
                        className="bold-text"
                        // Stable selector for title
                        data-tour={`title-${tabKey}-${accessType?.id}`}
                        style={{
                          background: "none",
                          border: "none",
                          padding: 0,
                          cursor: "pointer",
                          color: "inherit",
                          textAlign: i18n.language?.split('-')?.[0] === 'ar' ? "right" : "left",
                          ...((accessType?.path !== "active_directory" && accessType?.path !== "guest_invitation" && accessType?.path !== "idx_bulk_load" && accessType?.path !== "idx_self_service" && accessType?.path !== "suspend_service_account" && accessType?.path !== "guest_management" && accessType?.path !== "rapid_application_onboarding" && accessType?.path !== "review_application_onboarding") && {whiteSpace: "nowrap"}),
                          overflow: "hidden",
                          textOverflow: "ellipsis"
                        }}
                        data-tooltip-id={`title-tooltip-index-${accessType?.id}`} data-tooltip-content={accessType?.title}
                      >
                        {`${accessType?.title}`}
                      </div>
                      {accessType?.title?.length > 21 && <Tooltip id={`title-tooltip-index-${accessType?.id}`} place="top" style={{ maxWidth: '200px' }} type="light" effect="solid" />}
                      <span
                        className="secondary-text"
                        style={{
                          textAlign: i18n.language?.split('-')?.[0] === 'ar' ? "right" : "left",
                          fontSize: "13px",
                          wordBreak: "break-word",
                          display: "-webkit-box",
                          webkitBoxOrient: "vertical",
                          webkitLineClamp: "2",
                          overflow: "hidden"
                        }}
                        data-tooltip-id={`subTitle-tooltip-index-${accessType?.id}`} data-tooltip-content={accessType?.subTitle}
                      >
                        {`${accessType?.subTitle}`}
                      </span>
                      {accessType?.subTitle?.length > 42 && <Tooltip id={`subTitle-tooltip-index-${accessType?.id}`} place="top" style={{ maxWidth: '200px' }} type="light" effect="solid" />}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
  console.log(
  accessTypes.filter(item => item?.type === "Directory Services")
);
  return slides;
};


// const startSwitcherTour = React.useCallback(() => {
//   const items = getSwitcherItems();
//   if (!items.length) {
//     console.warn('Switcher tour: no clickable items found in #switcher.');
//     return;
//   }

//   // Build steps from actual DOM nodes (safer than string selectors)
//   const steps = items.map((el) => {
//     const label = getItemLabel(el);
//     // Try to map to a stable description by normalizing label
//     const key = label.toLowerCase().includes('directory') ? 'directory_services' : label;
//     const description = DESCRIPTIONS[key] || `Explore: ${label}`;

//     return {
//       element: el, // pass node directly to Driver.js
//       popover: {
//         title: `Tab: ${label || 'Item'}`,
//         description,
//         side: 'bottom',
//         align: 'start',
//       },
//     };
//   });

//   const d = driver({
//     showProgress: true,
//     overlayOpacity: 0.6,
//     stagePadding: 6,
//     allowClose: true,
//   });

//   // Driver.js accepts DOM elements in steps
//   d.setSteps(steps);
//   d.drive();
// }, []);



  return (
    <div id="welcome-container">
      <div className="card" style={{ gap: "0px" }}>
        <div className="card-content pb-0">
          <span
            className="sectionHeaderQuickLinks mb-3"
            style={{ textAlign: i18n.language?.split('-')?.[0] === 'ar' ? "right" : "left" }}
          >
            {t("homePage.quick_links")}
            {!/\/home(\/|$)/.test(window.location.pathname) &&
              selectedView === "halfCard" && (
                <Icon
                  icon="open_in_new"
                  style={{ color: "#005CBC" }}
                  size="small"
                  onClick={() => setSlectedCardView("fullCard")}
                />
              )}
            {!/\/home(\/|$)/.test(window.location.pathname) &&
              selectedView === "fullCard" && (
                <Icon
                  icon="open_in_new"
                  style={{ color: "#005CBC" }}
                  size="small"
                  onClick={() => setSlectedCardView("halfCard")}
                />
              )}
          </span>
          {isMobile && (
            <div className="quick-links" style={{ margin: "auto !important" }}>
              <Dropdown
                style={{ margin: "auto !important" }}
                // childList={quickLinks?.sort?.((a, b) => { return a?.displayText?.localeCompare?.(b.displayText); })}
                childList={quickLinks}
                selectedValue={selectedQuickLink}
                selection="single"
                setSelectedValue={(val) => selectedTab(val)}
                size="medium"
                onKeyDown={(e) => e.preventDefault()}
              />
            </div>
          )}
          {!isMobile && (
            <Switcher
              id="switcher"
              style={{ width: "400px", marginBottom: "16px" }}
              items={[{
                label: "myidM"
              },
              {
                label: "SSO"
              },
              {
                label: "pepAGM"
              },
              {
                label: "PKI"
              },
              {
                label: "myPAM"
              },
              {
                label: t("homePage.directory_services")
              },
              {
                label: "CIAM"
              }
              ]}
              onUpdate={(val) => selectedTab(val)}
              selectedItemIndex={quickLinkSelectedIndex}
            />
          )}
          {quickLinkSelectedIndex === 0 && (
            <div id="tab-myidM"
              key={isMobile}
              className={`card-content pb-0 ${userProfile?.systemsStatus?.myidM ? "disabled-card" : ""}`}
              style={{ padding: "0px" }}
            >
              <Carousel
                className="mb-0"
                key={carouselKey}
                itemData={renderSlides("myidM")}
                onStepChange={(step) => setCurrentStep(step)}
              />
            </div>
          )}
          {quickLinkSelectedIndex === 1 && (
            <div id="tab-SSO"
              key={isMobile}
              className={`card-content pb-0 ${userProfile?.systemsStatus?.SSO ? "disabled-card" : ""}`}
              style={{ padding: "0px" }}
            >
              <Carousel
                className="mb-0"
                itemData={renderSlides("SSO")}
                onStepChange={(step) => setCurrentStep(step)}
              />
            </div>
          )}
          {quickLinkSelectedIndex === 2 && (
            <div id="tab-pepAGM"
              key={isMobile}
              className={`card-content pb-0 ${userProfile?.systemsStatus?.pepAGM ? "disabled-card" : ""}`}
              style={{ padding: "0px" }}
            >
              <Carousel
                className="mb-0"
                itemData={renderSlides("pepAGM")}
                onStepChange={(step) => setCurrentStep(step)}
              />
            </div>
          )}
          {quickLinkSelectedIndex === 3 && (
            <div id="tab-PKI"
              key={isMobile}
              className={`card-content pb-0 ${userProfile?.systemsStatus?.PKI ? "disabled-card" : ""}`}
              style={{ padding: "0px" }}
            >
              <Carousel
                className="mb-0"
                itemData={renderSlides("PKI")}
                onStepChange={(step) => setCurrentStep(step)}
              />
            </div>
          )}
          {quickLinkSelectedIndex === 4 && (
            <div id="tab-myPAM"
              key={isMobile}
              className={`card-content pb-0 ${userProfile?.systemsStatus?.myPAM ? "disabled-card" : ""}`}
              style={{ padding: "0px" }}
            >
              <Carousel
                className="mb-0"
                itemData={renderSlides("myPAM")}
                onStepChange={(step) => setCurrentStep(step)}
              />
            </div>
          )}{" "}
          {quickLinkSelectedIndex === 5 && (
            <div id="tab-DS"
              key={isMobile}
              className={`card-content pb-0 ${userProfile?.systemsStatus?.DS ? "disabled-card" : ""}`}
              style={{ padding: "0px" }}
            >
              <Carousel
                className="mb-0"
                itemData={renderSlides("Directory Services")}
                onStepChange={(step) => setCurrentStep(step)}
              />
            </div>
          )}
          {quickLinkSelectedIndex === 6 && (
            <div id="tab-CIAM"
              key={isMobile}
              className={`card-content pb-0 ${userProfile?.systemsStatus?.CIAM ? "disabled-card" : ""}`}
              style={{ padding: "0px" }}
            >
              <Carousel
                className="mb-0"
                itemData={renderSlides("CIAM")}
                onStepChange={(step) => setCurrentStep(step)}
              />
            </div>
          )}
          {/* {quickLinkSelectedIndex === 7 && (
            <div
              key={isMobile}
              className="card-content"
              style={{ padding: "0px" }}
            >
              <Carousel
                itemData={[
                  <div
                    className="card "
                    key="more-services"
                    style={{ height: !isMobile ? "132px" : null }}
                  >
                    <div className="card-content">
                      <div
                        className={
                          isMobile
                            ? "d-grid m-auto"
                            : "d-flex justify-content-around"
                        }
                        style={{ gap: isMobile ? "20px" : "0px" }}
                      >
                        <div
                          className={isMobile ? "d-grid card" : "d-flex m-auto"}
                        >
                          <div className="myidM_Banner_logo"></div>
                          <div
                            className=""
                            style={{ margin: "auto", display: "grid" }}
                          >
                            <span
                              style={{ fontSize: "14px", color: "#3a3a3a" }}
                            >
                              {t("homePage.more_info_1")}{" "}
                            </span>
                            <span className="secondary-text">
                              {t("homePage.more_info_1_1")}{" "}
                              <span
                                onClick={() => {
                                  window.open(
                                    "http://myidm.mypepsico.com/",
                                    "_blank"
                                  );
                                }}
                                className="link"
                              >
                                {t("homePage.click_here")}{" "}
                              </span>
                              <Icon
                                alt="alt value"
                                className="$color-icon-default accordin-button-icon justify-content-center"
                                icon="arrow_forward"
                                size="medium"
                              />
                            </span>
                          </div>
                        </div>
                        <div
                          className={isMobile ? "d-grid card" : "d-flex m-auto"}
                        >
                          <div className="serviceNOW_Logo"></div>
                          <div
                            className=""
                            style={{ margin: "auto", display: "grid" }}
                          >
                            <span
                              style={{ fontSize: "14px", color: "#3a3a3a" }}
                            >
                              {t("homePage.more_info_2")}{" "}
                            </span>
                            <span className="secondary-text">
                              {t("homePage.more_info_2_2")}{" "}
                              <span
                                onClick={() => {
                                  window.open(
                                    "https://pepsico.service-now.com",
                                    "_blank"
                                  );
                                }}
                                className="link"
                              >
                                {t("homePage.click_here")}{" "}
                              </span>
                              <Icon
                                alt="alt value"
                                className="$color-icon-default accordin-button-icon justify-content-center"
                                icon="arrow_forward"
                                size="medium"
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>,
                ]}
                onStepChange={function Qa() { }}
              />
            </div>
          )} */}
          </div>
            <div
              key={isMobile}
              className="card-content pt-0"
              style={{ padding: "0px" }}
            >
              <Carousel
                showPagination={false}
                className="mt-0"
                itemData={[
                  <div
                    className="card border-none"
                    key="more-services"
                  >
                    <div className="card-content pt-0">
                      <div
                        // className={
                        //   window.screen.width <=1050
                        //     ? "d-grid m-auto mt-0"
                        //     : "d-flex justify-content-around mt-0"
                        // }
                        // style={{ gap: window.screen.width <=1050 ? "20px" : "0px" }}
                        style={{
                          display: "grid", 
                          gridGap: "1rem", 
                          gridTemplateColumns: isMobile ? "repeat(auto-fit, minmax(300px, 1fr))" : "minmax(150px, .9fr) minmax(170px, .9fr) minmax(305px, 1.2fr) minmax(270px, 1fr)"
                        }}
                      >
                        <div className="d-flex" style={{gap: isMobile ? "1rem" : ".5rem"}}
                            // className={window.screen.width <=1050 ? "d-grid card border-none box-shadow-none" : "d-flex m-auto"}
                          >
                            {/* <div className="w-auto d-flex justify-content-center"><img
                              src={view_request_icon}
                              style={{
                                width: "40px",
                                height: "40px",
                                flexShrink: "0",
                                aspectRatio: "25.00 / 25.00",
                                marginBottom: "10px"
                              }}
                              alt="Custom Feature"
                            /></div> */}
                            <div class="request_access_logo" style={{
                              margin: "revert",
                              width: "40px",
                              height: "40px",
                              flexShrink: "0",
                              aspectRatio: "25 / 25"
                            }}></div>
                            <div
                              className="my-auto"
                              style={{ display: "grid" }}
                            >
                              <span
                                style={{ fontSize: "14px", color: "#3a3a3a" }}
                              >
                                {t("homePage.view_request")}{" "}
                              </span>
                              <span className="secondary-text d-flex justify-content-start" style={{gap:"10px"}}>
                                <span className="d-flex link" style={{gap:"0"}}
                                  onClick={() => {
                                    if(userProfile?.pepappiamcentralfeatures?.includes('ContractorReactivation')) 
                                    {
                                      let statePayload = { navigateFrom: "extension_request"};
                                      navigate("/myidmPortal", { state: statePayload });
                                    }
                                    else{
                                      window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=ViewMyRequestsAuditSAP")
                                    }
                                  }}
                                  >
                                  <span>
                                    {t("homePage.click_here")}{" "}
                                  </span>
                                  <Icon
                                    alt="alt value"
                                    className="$color-icon-default accordin-button-icon justify-content-center"
                                    icon="arrow_forward"
                                    size="medium"
                                  />
                                </span>
                              </span>
                            </div>
                          </div>
                        {
                          // roles?.includes("powerBI") ? 
                          <div className="d-flex" style={{gap: isMobile ? "1rem" : ".5rem"}}
                            // className={window.screen.width <=1050 ? "d-grid card border-none box-shadow-none" : "d-flex m-auto"}
                          >
                            <div className="w-auto d-flex justify-content-center"><img
                              src={custom_icon}
                              style={{
                                width: "40px",
                                height: "40px",
                                flexShrink: "0",
                                aspectRatio: "25.00 / 25.00",
                              }}
                              alt="Custom Feature"
                            /></div>
                            <div
                              className="my-auto"
                              style={{ display: "grid" }}
                            >
                              <span
                                style={{ fontSize: "14px", color: "#3a3a3a" }}
                              >
                                {t("homePage.more_info_PBI")}{" "}
                              </span>
                              <span className="secondary-text d-flex justify-content-start" style={{gap:"10px"}}>
                                <span className="d-flex link" style={{gap:"0"}}
                                  onClick={() => navigate("/reports")}
                                  >
                                  <span>
                                    {t("homePage.click_here")}{" "}
                                  </span>
                                  <Icon
                                    alt="alt value"
                                    className="$color-icon-default accordin-button-icon justify-content-center"
                                    icon="arrow_forward"
                                    size="medium"
                                  />
                                </span>
                              </span>
                            </div>
                          </div>
                          // : null
                        }
                        <div className="d-flex" style={{gap: ".5rem"}}
                          // className={window.screen.width <=1050 ? "d-grid card border-none box-shadow-none" : "d-flex m-auto"}
                        >
                          <div className="myidM_Banner_logo mx-0"></div>
                          <div
                            className="my-auto"
                            style={{ display: "grid" }}
                          >
                            <span className="d-flex justify-content-start"
                              style={{ fontSize: "14px", color: "#3a3a3a" }}
                            >
                              {t("homePage.more_info_1")}{" "}
                            </span>
                            <span className="secondary-text d-flex justify-content-start" style={{gap:"10px"}}>
                              {/* {t("homePage.more_info_1_1")}{" "} */}
                              <span className="d-flex link" style={{gap:"0"}}
                                onClick={() => {
                                  window.open(
                                    "http://myidm.mypepsico.com/",
                                    "_blank"
                                  );
                                }}>
                                <span>
                                  {t("homePage.click_here")}{" "}
                                </span>
                                <Icon
                                  alt="alt value"
                                  className="$color-icon-default accordin-button-icon justify-content-center d-inline-block"
                                  icon="arrow_forward"
                                  size="medium"
                                />
                                </span>
                            </span>
                          </div>
                        </div>
                        <div className="d-flex" style={{gap: ".5rem"}}
                          // className={window.screen.width <=1050 ? "d-grid card border-none box-shadow-none" : "d-flex m-auto"}
                        >
                          <div className="serviceNOW_Logo mx-0"></div>
                          <div
                            className="my-auto"
                            style={{ display: "grid" }}
                          >
                            <span className="d-flex justify-content-start"
                              style={{ fontSize: "14px", color: "#3a3a3a" }}
                            >
                              {t("homePage.more_info_2")}{" "}
                            </span>
                          <span className="secondary-text d-flex justify-content-start" style={{gap:"10px"}}>
                              {/* {t("homePage.more_info_2_2")}{" "} */}
                              <span className="d-flex link" style={{gap:"0"}}
                                onClick={() => {
                                  window.open(
                                    "https://pepsico.service-now.com",
                                    "_blank"
                                  );
                                }}>
                                <span>
                                  {t("homePage.more_info_2_2")}{" "}
                                </span>
                                <Icon
                                  alt="alt value"
                                  className="$color-icon-default accordin-button-icon justify-content-center"
                                  icon="arrow_forward"
                                  size="medium"
                                />
                              </span>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>,
                ]}
                onStepChange={function Qa() { }}
              />
        </div>
      </div>
      {/* <Modal
        size="large"
        id="pkiCertsModal"
        className={isMobile ? "mobile-pki-certs-modal" : ""}
        closeOnOutsideClick
        onCloseModal={closePkiCertsModal}
        showCloseButton
        showModal={isPkiCertsModalOpen}
        style={{}}
        tertiaryButtonProps=""
        showAuxiliaryButton={false}
        showPrimaryButton={true}
        showSecondaryButton={false}
        primaryButtonProps={{
          text: 'View Certificates',
          variant: "primary",
          iconLeading: "arrow_forward",
          onClick: async () => {
            navigateToQuickLinks(pkiCertData.path, pkiCertData.target);
          },
        }}
        title="Certificate Info"
        type="fluid"
      >
        <div>
          <div className="d-flex w-100 flex-wrap" style={{ gap: "8px" }}>
            <div className="my_Cert_certificate_info"></div>
          </div>
        </div>
      </Modal> */}
    </div>
  );
};

export default WelcomeJs;
